module.exports = __webpack_public_path__ + "9f2cdb2a5951549de757abd69eb128dd.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-medium.ttf
// module id = 98
// module chunks = 0